import { useState } from 'react';
import { Download } from 'lucide-react';
import { getFileUrl } from '../../lib/storage';

export const FileDownloadLink = ({ file }) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async (e) => {
    e.preventDefault();
    if (!file.path) return;
    setLoading(true);
    const url = await getFileUrl(file.path);
    setLoading(false);
    if (url) window.open(url, '_blank');
  };

  return (
    <button
      onClick={handleClick}
      disabled={!file.path || loading}
      className="flex items-center gap-1 text-xs text-blue-600 hover:underline disabled:text-slate-400"
    >
      <Download className="w-3 h-3" />
      {loading ? 'Loading...' : file.name}
      {!file.path && <span className="text-slate-400">(not stored)</span>}
    </button>
  );
};
